import type { NearbyProvider } from "../nearby-providers";
import { reviewsLine } from "./reviews-line";

function dogsLine(listingCount: number): string {
    if (listingCount === 0) return "No dogs listed";
    return `${listingCount} ${listingCount === 1 ? "dog" : "dogs"} available`;
}

export function formatNearbyProviderDetail({
    city,
    state,
    listingCount,
    reviewCount,
}: Pick<
    NearbyProvider,
    "city" | "state" | "listingCount" | "reviewCount"
>): string {
    const place = [city, state].filter(Boolean).join(", ");
    return [place, dogsLine(listingCount), reviewsLine(reviewCount)]
        .filter(Boolean)
        .join(" · ");
}
